import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { map, size, filter, cond, stubTrue, isEmpty, includes } from 'lodash';
import If from 'components/helpers/if';
import ConfigurationCheckbox from 'components/widgets/ConfigurationCheckbox';
import './MultiSelect.scss';

const MultiSelect = ({
    className,
    label,
    options,
    isDisabled,
    onChange,
    displaySelectAll = true,
    selected = []
}) => {
    const optionsLength = size(options);
    const isSelectAllChecked = optionsLength === size(selected);
    const selectSize = optionsLength < 4 ? optionsLength + (displaySelectAll ? 1 : 0) : 4;
    const handleChange = (code, value) => {
        const newSelected = cond([
            [() => code === 'all', () => value ? [] : map(options, 'code')],
            [stubTrue, () => value ? filter(selected, selectedCode => selectedCode !== code) : [...selected, code]]
        ])()
        onChange(newSelected);
    };

    if (isEmpty(options)) {
        return null;
    }

    return (
        <fieldset
            className={classNames('spark-multi-select', className)}
            size={selectSize}
            disabled={isDisabled}
        >
            {label && <h4 className="spark-multi-select__label">{label}</h4>}
            <fieldset className="spark-multi-select__container spark-padding-top">
                <If condition={displaySelectAll}>
                    <ConfigurationCheckbox
                        className="multi-select-checkbox"
                        code="all"
                        title="Select All"
                        TitleTag="span"
                        value={isSelectAllChecked}
                        isDisabled={isDisabled}
                        onChange={handleChange}
                    />
                </If>
                {map(options, ({ code, label }, index) => (
                    <ConfigurationCheckbox
                        key={code}
                        className={classNames('multi-select-checkbox',
                            { 'checkbox-no-margin': optionsLength < selectSize && index === optionsLength - 1 })}
                        code={code}
                        title={label}
                        TitleTag="span"
                        value={includes(selected, code)}
                        isDisabled={isDisabled}
                        onChange={handleChange}
                    />
                ))}
            </fieldset>
        </fieldset>
    );
};

MultiSelect.propTypes = {
    className: PropTypes.string,
    displaySelectAll: PropTypes.bool,
    isDisabled: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    options: PropTypes.array,
    onChange: PropTypes.func,
    selected: PropTypes.arrayOf(PropTypes.string)
};

export default MultiSelect;


// WEBPACK FOOTER //
// ./src/components/common/MultiSelect.js